import { render, staticRenderFns } from "./MoveUserSys.vue?vue&type=template&id=5405d6be"
import script from "./MoveUserSys.vue?vue&type=script&lang=js"
export * from "./MoveUserSys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports